import { combineStrings } from '../string';

export type AddressType = {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
};

export const formatAddress = (address: AddressType) =>
  combineStrings([
    `${combineStrings([address.address1, address.address2])},`,
    address.city ? `${address.city},` : '',
    address.state ? address.state.toUpperCase() : '',
    address.zip,
  ]);

/**
 * Converts an ISO-3166-2 US code like "US-CA" to the USPS code "CA".
 * Returns the input unchanged if it doesn't match.
 */
export const formatUsStateCode = (state?: string): string | undefined => {
  if (!state || !state?.startsWith('US-')) return state;

  return state?.toUpperCase()?.replace('US-', '');
};
